import { useLocation } from "react-router-dom";
import { useDetalleMutuo } from "../../../context/mutuoContext";
import { useEffect, useState } from "react";
import { Card, Grid2 } from "@mui/material";
import TabsContainer from "../../../components/ui/materialui/TabsContainer";
import Breadcrumb from "../../../components/ui/materialui/breadcrumb";
import Dividendos from "../components/dividendos";
import DividendosImpagos from "../components/dividendosImpagos";
import ComportamientoPago from "../components/comportamientoPago";
import GenerarDividendo from "../components/generarDividendo";
import { IsDesactivado } from "../../detalleMutuo/services/servicesMutuo";
import { StatusCode, TipoFuncionalidad } from "../../../utils/enums";
import { PermissionGuard } from "../../../components/auth/ProtectedRoute";

interface DividendoProps {
    activeTab?: number;
}

interface Origen {
    labelBreadCrumb: string;
    urlBradCrumb: string;
}

const Dividendo: React.FC<DividendoProps> = ({ activeTab = 0 }) => {

    const location = useLocation();
    const { id: idEmergente } = location.state || {}
    const [idMutuo, setIdMutuo] = useState<number>(idEmergente);
    const { id, nombre, filtros, tipoMutuo, idSolicitud, numeroOperacion } = useDetalleMutuo();
    const [showGenerarDividendo, setShowGenerarDividendo] = useState<boolean>(false);
    const [isDesactivado, setIsDesactivado] = useState(false);


    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cartera mutuos', state: filtros, url: '/cartera-mutuos' },
        { label: 'Dividendo', active: true },
        { label: `${numeroOperacion ?? ''} - ${tipoMutuo ?? ""} - ${nombre ?? ''}`, active: true },
    ]

    const handleCancelar = () => {
        setShowGenerarDividendo(false);
    }

    const EsDesactivado = async (mutuoId: number) => {
        const resp = await IsDesactivado(mutuoId);
        if (resp.status === StatusCode.Ok) {
            setIsDesactivado(resp.data.valor);
        }
    }

    useEffect(() => {
        EsDesactivado(idMutuo);
    }, [idMutuo])

    return (
        <>
            <Grid2 size={{ xs: 12, lg: 8 }}>
                <Breadcrumb items={breadcrumbItems} />
            </Grid2>
            {
                showGenerarDividendo ?
                    <GenerarDividendo idMutuo={idMutuo} handleCancelar={handleCancelar} />
                    :

                    <>
                        <Grid2 size={{ xs: 12, lg: 8 }}>
                        </Grid2>

                        {/* TAB */}
                        <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                            <PermissionGuard
                                permission={TipoFuncionalidad.Cartera_ver}>
                                <TabsContainer
                                    activeTab={activeTab}
                                    tabs={[
                                        { label: 'Dividendos', content: <Dividendos idMutuo={idMutuo} setShowGenerarDividendo={setShowGenerarDividendo} isDesactivado={isDesactivado} /> },
                                        { label: 'Dividendos Impagos', content: <DividendosImpagos idMutuo={idMutuo} isDesactivado={isDesactivado} /> },
                                        { label: 'Comportamiento de pagos', content: <ComportamientoPago idMutuo={idMutuo} /> },

                                    ]}
                                />
                            </PermissionGuard>
                        </Card>
                    </>
            }

        </>
    )
}

export default Dividendo;